import scrollTo from './scrollTo';

const automaticScrollForm = inputReference => {
  scrollTo(inputReference, 200, 'content');
};

export default automaticScrollForm;
